/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BatchProductsDto } from '../../models/batch-products-dto';
import { DispatchProductsResponseDto } from '../../models/dispatch-products-response-dto';

export interface ProductsControllerBatch$Params {
  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id': string;
  body: BatchProductsDto;
}

export function productsControllerBatch(
  http: HttpClient,
  rootUrl: string,
  params: ProductsControllerBatch$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<DispatchProductsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, productsControllerBatch.PATH, 'post');
  if (params) {
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DispatchProductsResponseDto>;
    })
  );
}

productsControllerBatch.PATH = '/api/v1/products/batch';
